import dayjs from "dayjs";

export const formatted = (date: string | null): string => {
  if (!date) {
    return "";
  } else {
    return dayjs(date).format("YYYY年MM月DD日");
  }
};
